import { getData } from '../assets/scripts/GeneralFunctions'
import { setUserMobile } from '../redux'

export const mobileSubmitForm = async (navigate, dispatch, mobile, setError, setDuration) => {
  let api_result = await getData(
    'customer/login',
    'post',
    {
      mobile: mobile,
    },
    false
  )
  if (api_result?.status === 200) {
    if (setDuration) {
      setDuration(api_result.data?.['remaining_time'])
    } else {
      const state = {
        remaining: api_result.data?.['remaining_time'],
        mobile: mobile,
      }
      dispatch(setUserMobile(mobile))
      navigate('/verify-code', { state })
    }
  } else if (api_result?.status === 400) {
    setError(api_result.error)
  }
}

export const verifyCodeSubmitFunction = async (mobile, code, setFormErrors, navigate) => {
  let apiResult = await getData(
    'customer/verify',
    'post',
    {
      mobile: mobile,
      verify_code: code,
    },
    false
  )
  if (apiResult?.status === 200) {
    navigate('/user/car')
    localStorage.setItem('userToken', apiResult?.data?.token)
  } else {
    setFormErrors(apiResult?.error)
  }
}
